export const CREATE_EVALUATION = 'CREATE_EVALUATION';
export const GET_EVALUATIONS = 'GET_EVALUATIONS';
export const GET_EVALUATION = 'GET_EVALUATION';
export const UPDATE_EVALUATION = 'UPDATE_EVALUATION';
export const DELETE_EVALUATION = 'DELETE_EVALUATION';
export const DELETE_EVALUATIONS = 'DELETE_EVALUATIONS';
